import rpmService from "../../Services/rpmService";

export const FETCH_VTIALSRANGELIST_REQUEST = "FETCH_VTIALSRANGELIST_REQUEST";
export const FETCH_VTIALSRANGELIST_SUCCESS = "FETCH_VTIALSRANGELIST_SUCCESS";
export const FETCH_VTIALSRANGELIST_FAILURE = "FETCH_VTIALSRANGELIST_FAILURE";

export const FETCH_DEVICESLIST_REQUEST = "FETCH_DEVICESLIST_REQUEST";
export const FETCH_DEVICESLIST_SUCCESS = "FETCH_DEVICESLIST_SUCCESS";
export const FETCH_DEVICESLIST_FAILURE = "FETCH_DEVICESLIST_FAILURE";

export const FETCH_TASKSLIST_REQUEST = "FETCH_TASKSLIST_REQUEST";
export const FETCH_TASKSLIST_SUCCESS = "FETCH_TASKSLIST_SUCCESS";
export const FETCH_TASKSLIST_FAILURE = "FETCH_TASKSLIST_FAILURE";

export const FETCH_FREQUENCIESLIST_REQUEST = "FETCH_FREQUENCIESLIST_REQUEST";
export const FETCH_FREQUENCIESLIST_SUCCESS = "FETCH_FREQUENCIESLIST_SUCCESS";
export const FETCH_FREQUENCIESLIST_FAILURE = "FETCH_FREQUENCIESLIST_FAILURE";

export const FETCH_ALERTSLIST_REQUEST = "FETCH_ALERTSLIST_REQUEST";
export const FETCH_ALERTSLIST_SUCCESS = "FETCH_ALERTSLIST_SUCCESS";
export const FETCH_ALERTSLIST_FAILURE = "FETCH_ALERTSLIST_FAILURE";

export const FETCH_PATIENTMAPPEDEVICESLIST_REQUEST = "FETCH_PATIENTMAPPEDEVICESLIST_REQUEST";
export const FETCH_PATIENTMAPPEDEVICESLIST_SUCCESS = "FETCH_PATIENTMAPPEDEVICESLIST_SUCCESS";
export const FETCH_PATIENTMAPPEDEVICESLIST_FAILURE = "FETCH_PATIENTMAPPEDEVICESLIST_FAILURE";

export const FETCH_REVIEWSLIST_REQUEST = "FETCH_REVIEWSLIST_REQUEST";
export const FETCH_REVIEWSLIST_SUCCESS = "FETCH_REVIEWSLIST_SUCCESS";
export const FETCH_REVIEWSLIST_FAILURE = "FETCH_REVIEWSLIST_FAILURE";

export const FETCH_CARETASKSLIST_REQUEST = "FETCH_CARETASKSLIST_REQUEST";
export const FETCH_CARETASKSLIST_SUCCESS = "FETCH_CARETASKSLIST_SUCCESS";
export const FETCH_CARETASKSLIST_FAILURE = "FETCH_CARETASKSLIST_FAILURE";

export const FETCH_CAREDAILYTASKSLIST_REQUEST = "FETCH_CAREDAILYTASKSLIST_REQUEST";
export const FETCH_CAREDAILYTASKSLIST_SUCCESS = "FETCH_CAREDAILYTASKSLIST_SUCCESS";
export const FETCH_CAREDAILYTASKSLIST_FAILURE = "FETCH_CAREDAILYTASKSLIST_FAILURE";

export const FETCH_CAREMEDICATIONSLIST_REQUEST = "FETCH_CAREMEDICATIONSLIST_REQUEST";
export const FETCH_CAREMEDICATIONSLIST_SUCCESS = "FETCH_CAREMEDICATIONSLIST_SUCCESS";
export const FETCH_CAREMEDICATIONSLIST_FAILURE = "FETCH_CAREMEDICATIONSLIST_FAILURE";

export const FETCH_CAREDAILYMEDLIST_REQUEST = "FETCH_CAREDAILYMEDLIST_REQUEST";
export const FETCH_CAREDAILYMEDLIST_SUCCESS = "FETCH_CAREDAILYMEDLIST_SUCCESS";
export const FETCH_CAREDAILYMEDLIST_FAILURE = "FETCH_CAREDAILYMEDLIST_FAILURE";

export const FETCH_USERNOTESTOPATIENT_REQUEST = "FETCH_USERNOTESTOPATIENT_REQUEST";
export const FETCH_USERNOTESTOPATIENT_SUCCESS = "FETCH_USERNOTESTOPATIENT_SUCCESS";
export const FETCH_USERNOTESTOPATIENT_FAILURE = "FETCH_USERNOTESTOPATIENT_FAILURE";

export const FETCH_ACTIVITYREPORT_REQUEST = "FETCH_ACTIVITYREPORT_REQUEST";
export const FETCH_ACTIVITYREPORT_SUCCESS = "FETCH_ACTIVITYREPORT_SUCCESS";
export const FETCH_ACTIVITYREPORT_FAILURE = "FETCH_ACTIVITYREPORT_FAILURE";

export const FETCH_RPMCONFIGVITALSLIST_REQUEST = "FETCH_RPMCONFIGVITALSLIST_REQUEST";
export const FETCH_RPMCONFIGVITALSLIST_SUCCESS = "FETCH_RPMCONFIGVITALSLIST_SUCCESS";
export const FETCH_RPMCONFIGVITALSLIST_FAILURE = "FETCH_RPMCONFIGVITALSLIST_FAILURE";

export const FETCH_PATCLINICALSTATUS_REQUEST = "FETCH_PATCLINICALSTATUS_REQUEST";
export const FETCH_PATCLINICALSTATUS_SUCCESS = "FETCH_PATCLINICALSTATUS_SUCCESS";
export const FETCH_PATCLINICALSTATUS_FAILURE = "FETCH_PATCLINICALSTATUS_FAILURE";

export const FETCH_PATCALENDERACTIVITY_REQUEST = "FETCH_PATCALENDERACTIVITY_REQUEST";
export const FETCH_PATCALENDERACTIVITY_SUCCESS = "FETCH_PATCALENDERACTIVITY_SUCCESS";
export const FETCH_PATCALENDERACTIVITY_FAILURE = "FETCH_PATCALENDERACTIVITY_FAILURE";

export const FETCH_RPMPATIENTFILTERCOUNT_REQUEST = "FETCH_RPMPATIENTFILTERCOUNT_REQUEST";
export const FETCH_RPMPATIENTFILTERCOUNT_SUCCESS = "FETCH_RPMPATIENTFILTERCOUNT_SUCCESS";
export const FETCH_RPMPATIENTFILTERCOUNT_FAILURE = "FETCH_RPMPATIENTFILTERCOUNT_FAILURE";

export const FETCH_RPMLOCWISECHRONICS_REQUEST = "FETCH_RPMLOCWISECHRONICS_REQUEST";
export const FETCH_RPMLOCWISECHRONICS_SUCCESS = "FETCH_RPMLOCWISECHRONICS_SUCCESS";
export const FETCH_RPMLOCWISECHRONICS_FAILURE = "FETCH_RPMLOCWISECHRONICS_FAILURE";

export const FETCH_RPMAGEWISECHRONICS_REQUEST = "FETCH_RPMAGEWISECHRONICS_REQUEST";
export const FETCH_RPMAGEWISECHRONICS_SUCCESS = "FETCH_RPMAGEWISECHRONICS_SUCCESS";
export const FETCH_RPMAGEWISECHRONICS_FAILURE = "FETCH_RPMAGEWISECHRONICS_FAILURE";

export const FETCH_DASHBOARDCOMPLIANCE_REQUEST = "FETCH_DASHBOARDCOMPLIANCE_REQUEST";
export const FETCH_DASHBOARDCOMPLIANCE_SUCCESS = "FETCH_DASHBOARDCOMPLIANCE_SUCCESS";
export const FETCH_DASHBOARDCOMPLIANCE_FAILURE = "FETCH_DASHBOARDCOMPLIANCE_FAILURE";

export const SET_SELECTEDRPM_PATIENT = "SET_SELECTEDRPM_PATIENT";
export const CLEAR_SELECTEDRPM_PATIENT = "CLEAR_SELECTEDRPM_PATIENT";

export const fetchRpmVitalsRangeList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_VTIALSRANGELIST_REQUEST });
    try {
        const response = await rpmService.rpmVitalRangeList(payload);
        dispatch({ type: FETCH_VTIALSRANGELIST_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: FETCH_VTIALSRANGELIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmDevicesList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_DEVICESLIST_REQUEST });
    try {
        const response = await rpmService.rpmDevicesList(payload);
        dispatch({ type: FETCH_DEVICESLIST_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: FETCH_DEVICESLIST_FAILURE, payload: error.message });
    }
}

export const fetchPatMappedRpmDevList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_PATIENTMAPPEDEVICESLIST_REQUEST });
    try {
        const response = await rpmService.patientMappedDevicesList(payload);
        dispatch({ type: FETCH_PATIENTMAPPEDEVICESLIST_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: FETCH_PATIENTMAPPEDEVICESLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmTasksList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_TASKSLIST_REQUEST });
    try {
        const response = await rpmService.rpmTasksList(payload);
        dispatch({ type: FETCH_TASKSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_TASKSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmFrequenciesList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_FREQUENCIESLIST_REQUEST });
    try {
        const response = await rpmService.rpmFrequenciesList(payload);
        dispatch({ type: FETCH_FREQUENCIESLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_FREQUENCIESLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmAlertsList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_ALERTSLIST_REQUEST });
    try {
        const response = await rpmService.rpmAlertsList(payload);
        dispatch({ type: FETCH_ALERTSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_ALERTSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmReviewsList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_REVIEWSLIST_REQUEST });
    try {
        const response = await rpmService.rpmReviewsList(payload);
        dispatch({ type: FETCH_REVIEWSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_REVIEWSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmCarePlanTaskList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_CARETASKSLIST_REQUEST });
    try {
        const response = await rpmService.rpmCarePlanTaskList(payload);
        dispatch({ type: FETCH_CARETASKSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_CARETASKSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmCarePlanDailyTaskList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_CAREDAILYTASKSLIST_REQUEST });
    try {
        const response = await rpmService.rpmCarePlanDailyTaskList(payload);
        dispatch({ type: FETCH_CAREDAILYTASKSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_CAREDAILYTASKSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmUserNotesToPatientList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_USERNOTESTOPATIENT_REQUEST });
    try {
        const response = await rpmService.userNotesToPatientList(payload);
        dispatch({ type: FETCH_USERNOTESTOPATIENT_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_USERNOTESTOPATIENT_FAILURE, payload: error.message });
    }
}

export const fetchRpmCPDailyMedicationList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_CAREDAILYMEDLIST_REQUEST });
    try {
        const response = await rpmService.rpmCarePlanDailyMedList(payload);
        dispatch({ type: FETCH_CAREDAILYMEDLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_CAREDAILYMEDLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmCPMedicationsList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_CAREMEDICATIONSLIST_REQUEST });
    try {
        const response = await rpmService.rpmCarePlanMedicationsList(payload);
        dispatch({ type: FETCH_CAREMEDICATIONSLIST_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_CAREMEDICATIONSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmActivityReport = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_ACTIVITYREPORT_REQUEST });
    try {
        const response = await rpmService.rpmActivityReport(payload);
        dispatch({ type: FETCH_ACTIVITYREPORT_SUCCESS, payload: response.data[0] });
    } catch (error) {
        dispatch({ type: FETCH_ACTIVITYREPORT_FAILURE, payload: error.message });
    }
}

export const fetchRpmConfiguredVitalsList = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_RPMCONFIGVITALSLIST_REQUEST });
    try {
        const response = await rpmService.rpmConfiguredVitalList(payload);
        dispatch({ type: FETCH_RPMCONFIGVITALSLIST_SUCCESS, payload: response.data.data[0] });
    } catch (error) {
        dispatch({ type: FETCH_RPMCONFIGVITALSLIST_FAILURE, payload: error.message });
    }
}

export const fetchRpmPatientClinicalStatus = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_PATCLINICALSTATUS_REQUEST });
    try {
        const response = await rpmService.rpmPatientClinicalStatus(payload);
        dispatch({ type: FETCH_PATCLINICALSTATUS_SUCCESS, payload: response.data?.[0] });
    } catch (error) {
        dispatch({ type: FETCH_PATCLINICALSTATUS_FAILURE, payload: error.message });
    }
}

export const fetchRpmPatCalenderActivity = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_PATCALENDERACTIVITY_REQUEST });
    try {
        const response = await rpmService.rpmCalenderActivity(payload);
        dispatch({ type: FETCH_PATCALENDERACTIVITY_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_PATCALENDERACTIVITY_FAILURE, payload: error.message });
    }
}

export const fetchRpmPatientFilterCount = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_RPMPATIENTFILTERCOUNT_REQUEST });
    try {
        const response = await rpmService.rpmPatientFilterCount(payload);
        dispatch({ type: FETCH_RPMPATIENTFILTERCOUNT_SUCCESS, payload: response.data });
    } catch (error) {
        dispatch({ type: FETCH_RPMPATIENTFILTERCOUNT_FAILURE, payload: error.message });
    }
}

export const fetchRpmLocationWiseChronics = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_RPMLOCWISECHRONICS_REQUEST });
    try {
        const response = await rpmService.rpmLocationWiseChronicList(payload);
        dispatch({ type: FETCH_RPMLOCWISECHRONICS_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: FETCH_RPMLOCWISECHRONICS_FAILURE, payload: error.message });
    }
}

export const fetchRpmAgeWiseChronics = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_RPMAGEWISECHRONICS_REQUEST });
    try {
        const response = await rpmService.rpmAgeWiseChronicList(payload);
        dispatch({ type: FETCH_RPMAGEWISECHRONICS_SUCCESS, payload: response.data.data });
    } catch (error) {
        dispatch({ type: FETCH_RPMAGEWISECHRONICS_FAILURE, payload: error.message });
    }
}

export const fetchRpmDashboardCompliance = (payload) => async(dispatch) => {
    dispatch({ type: FETCH_DASHBOARDCOMPLIANCE_REQUEST });
    try {
        const response = await rpmService.fetchRpmDbCompliance(payload);
        dispatch({ type: FETCH_DASHBOARDCOMPLIANCE_SUCCESS, payload: response.data?.[0] });
    } catch (error) {
        dispatch({ type: FETCH_DASHBOARDCOMPLIANCE_FAILURE, payload: error.message });
    }
}


export const setSelectedRpmPatient = (patient) => ({
  type: SET_SELECTEDRPM_PATIENT,
  payload: patient,
});

export const clearSelectedRpmPatient = (patient) => ({
  type: CLEAR_SELECTEDRPM_PATIENT,
  payload: patient,
});